// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetAuth (params?: {}): Promise<Dict>;
    publicGetExchangeToken (params?: {}): Promise<Dict>;
    publicGetForkToken (params?: {}): Promise<Dict>;
    publicGetSetHeartbeat (params?: {}): Promise<Dict>;
    publicGetDisableHeartbeat (params?: {}): Promise<Dict>;
    publicGetGetTime (params?: {}): Promise<Dict>;
    publicGetHello (params?: {}): Promise<Dict>;
    publicGetStatus (params?: {}): Promise<Dict>;
    publicGetTest (params?: {}): Promise<Dict>;
    publicGetSubscribe (params?: {}): Promise<Dict>;
    publicGetUnsubscribe (params?: {}): Promise<Dict>;
    publicGetUnsubscribeAll (params?: {}): Promise<Dict>;
    publicGetGetAnnouncements (params?: {}): Promise<Dict>;
    publicGetGetAprHistory (params?: {}): Promise<Dict>;
    publicGetGetBookSummaryByCurrency (params?: {}): Promise<Dict>;
    publicGetGetBookSummaryByInstrument (params?: {}): Promise<Dict>;
    publicGetGetContractSize (params?: {}): Promise<Dict>;
    publicGetGetCurrencies (params?: {}): Promise<Dict>;
    publicGetGetDeliveryPrices (params?: {}): Promise<Dict>;
    publicGetGetExpirations (params?: {}): Promise<Dict>;
    publicGetGetFundingChartData (params?: {}): Promise<Dict>;
    publicGetGetFundingRateHistory (params?: {}): Promise<Dict>;
    publicGetGetFundingRateValue (params?: {}): Promise<Dict>;
    publicGetGetHistoricalVolatility (params?: {}): Promise<Dict>;
    publicGetGetIndex (params?: {}): Promise<Dict>;
    publicGetGetIndexChartData (params?: {}): Promise<Dict>;
    publicGetGetIndexPrice (params?: {}): Promise<Dict>;
    publicGetGetIndexPriceNames (params?: {}): Promise<Dict>;
    publicGetGetInstrument (params?: {}): Promise<Dict>;
    publicGetGetInstruments (params?: {}): Promise<Dict>;
    publicGetGetLastSettlementsByCurrency (params?: {}): Promise<Dict>;
    publicGetGetLastSettlementsByInstrument (params?: {}): Promise<Dict>;
    publicGetGetLastTradesByCurrency (params?: {}): Promise<Dict>;
    publicGetGetLastTradesByCurrencyAndTime (params?: {}): Promise<Dict>;
    publicGetGetLastTradesByInstrument (params?: {}): Promise<Dict>;
    publicGetGetLastTradesByInstrumentAndTime (params?: {}): Promise<Dict>;
    publicGetGetMarkPriceHistory (params?: {}): Promise<Dict>;
    publicGetGetOrderBook (params?: {}): Promise<Dict>;
    publicGetGetSupportedIndexNames (params?: {}): Promise<Dict>;
    publicGetGetTradeVolumes (params?: {}): Promise<Dict>;
    publicGetGetTradingviewChartData (params?: {}): Promise<Dict>;
    publicGetGetVolatilityIndexData (params?: {}): Promise<Dict>;
    publicGetTicker (params?: {}): Promise<Dict>;
    privateGetLogout (params?: {}): Promise<Dict>;
    privateGetEnableCancelOnDisconnect (params?: {}): Promise<Dict>;
    privateGetDisableCancelOnDisconnect (params?: {}): Promise<Dict>;
    privateGetGetCancelOnDisconnect (params?: {}): Promise<Dict>;
    privateGetSubscribe (params?: {}): Promise<Dict>;
    privateGetUnsubscribe (params?: {}): Promise<Dict>;
    privateGetUnsubscribeAll (params?: {}): Promise<Dict>;
    privateGetChangeApiKeyName (params?: {}): Promise<Dict>;
    privateGetChangeScopeInApiKey (params?: {}): Promise<Dict>;
    privateGetChangeSubaccountName (params?: {}): Promise<Dict>;
    privateGetCreateApiKey (params?: {}): Promise<Dict>;
    privateGetCreateSubaccount (params?: {}): Promise<Dict>;
    privateGetDisableApiKey (params?: {}): Promise<Dict>;
    privateGetDisableTfaForSubaccount (params?: {}): Promise<Dict>;
    privateGetEnableAffiliateProgram (params?: {}): Promise<Dict>;
    privateGetEnableApiKey (params?: {}): Promise<Dict>;
    privateGetGetAccessLog (params?: {}): Promise<Dict>;
    privateGetGetAccountSummary (params?: {}): Promise<Dict>;
    privateGetGetAccountSummaries (params?: {}): Promise<Dict>;
    privateGetGetAffiliateProgramInfo (params?: {}): Promise<Dict>;
    privateGetGetCurrencies (params?: {}): Promise<Dict>;
    privateGetGetEmailLanguage (params?: {}): Promise<Dict>;
    privateGetGetNewAnnouncements (params?: {}): Promise<Dict>;
    privateGetGetPortfolioMargins (params?: {}): Promise<Dict>;
    privateGetGetPosition (params?: {}): Promise<Dict>;
    privateGetGetPositions (params?: {}): Promise<Dict>;
    privateGetGetSubaccounts (params?: {}): Promise<Dict>;
    privateGetGetSubaccountsDetails (params?: {}): Promise<Dict>;
    privateGetGetTransactionLog (params?: {}): Promise<Dict>;
    privateGetListApiKeys (params?: {}): Promise<Dict>;
    privateGetRemoveApiKey (params?: {}): Promise<Dict>;
    privateGetRemoveSubaccount (params?: {}): Promise<Dict>;
    privateGetResetApiKey (params?: {}): Promise<Dict>;
    privateGetSetAnnouncementAsRead (params?: {}): Promise<Dict>;
    privateGetSetApiKeyAsDefault (params?: {}): Promise<Dict>;
    privateGetSetDisabledTradingProducts (params?: {}): Promise<Dict>;
    privateGetSetEmailForSubaccount (params?: {}): Promise<Dict>;
    privateGetSetEmailLanguage (params?: {}): Promise<Dict>;
    privateGetSetPasswordForSubaccount (params?: {}): Promise<Dict>;
    privateGetSimulatePortfolio (params?: {}): Promise<Dict>;
    privateGetToggleNotificationsFromSubaccount (params?: {}): Promise<Dict>;
    privateGetToggleSubaccountLogin (params?: {}): Promise<Dict>;
    privateGetApproveBlockTrade (params?: {}): Promise<Dict>;
    privateGetExecuteBlockTrade (params?: {}): Promise<Dict>;
    privateGetGetBlockTrade (params?: {}): Promise<Dict>;
    privateGetGetBlockTradeRequests (params?: {}): Promise<Dict>;
    privateGetGetBlockTrades (params?: {}): Promise<Dict>;
    privateGetGetLastBlockTradesByCurrency (params?: {}): Promise<Dict>;
    privateGetInvalidateBlockTradeSignature (params?: {}): Promise<Dict>;
    privateGetRejectBlockTrade (params?: {}): Promise<Dict>;
    privateGetSimulateBlockTrade (params?: {}): Promise<Dict>;
    privateGetVerifyBlockTrade (params?: {}): Promise<Dict>;
    privateGetBuy (params?: {}): Promise<Dict>;
    privateGetSell (params?: {}): Promise<Dict>;
    privateGetEdit (params?: {}): Promise<Dict>;
    privateGetEditByLabel (params?: {}): Promise<Dict>;
    privateGetCancel (params?: {}): Promise<Dict>;
    privateGetCancelAll (params?: {}): Promise<Dict>;
    privateGetCancelAllByCurrency (params?: {}): Promise<Dict>;
    privateGetCancelAllByInstrument (params?: {}): Promise<Dict>;
    privateGetCancelByLabel (params?: {}): Promise<Dict>;
    privateGetCancelQuotes (params?: {}): Promise<Dict>;
    privateGetClosePosition (params?: {}): Promise<Dict>;
    privateGetGetMargins (params?: {}): Promise<Dict>;
    privateGetGetMmpConfig (params?: {}): Promise<Dict>;
    privateGetGetMmpStatus (params?: {}): Promise<Dict>;
    privateGetGetOpenOrders (params?: {}): Promise<Dict>;
    privateGetGetOpenOrdersByCurrency (params?: {}): Promise<Dict>;
    privateGetGetOpenOrdersByInstrument (params?: {}): Promise<Dict>;
    privateGetGetOpenOrdersByLabel (params?: {}): Promise<Dict>;
    privateGetGetOrderHistoryByCurrency (params?: {}): Promise<Dict>;
    privateGetGetOrderHistoryByInstrument (params?: {}): Promise<Dict>;
    privateGetGetOrderMarginByIds (params?: {}): Promise<Dict>;
    privateGetGetOrderState (params?: {}): Promise<Dict>;
    privateGetGetOrderStateByLabel (params?: {}): Promise<Dict>;
    privateGetGetStopOrderHistory (params?: {}): Promise<Dict>;
    privateGetGetTriggerOrderHistory (params?: {}): Promise<Dict>;
    privateGetGetUserTradesByCurrency (params?: {}): Promise<Dict>;
    privateGetGetUserTradesByCurrencyAndTime (params?: {}): Promise<Dict>;
    privateGetGetUserTradesByInstrument (params?: {}): Promise<Dict>;
    privateGetGetUserTradesByInstrumentAndTime (params?: {}): Promise<Dict>;
    privateGetGetUserTradesByOrder (params?: {}): Promise<Dict>;
    privateGetMassQuote (params?: {}): Promise<Dict>;
    privateGetMovePositions (params?: {}): Promise<Dict>;
    privateGetResetMmp (params?: {}): Promise<Dict>;
    privateGetSetMmpConfig (params?: {}): Promise<Dict>;
    privateGetGetSettlementHistoryByInstrument (params?: {}): Promise<Dict>;
    privateGetGetSettlementHistoryByCurrency (params?: {}): Promise<Dict>;
    privateGetAddToAddressBook (params?: {}): Promise<Dict>;
    privateGetCancelTransferById (params?: {}): Promise<Dict>;
    privateGetCancelWithdrawal (params?: {}): Promise<Dict>;
    privateGetCreateDepositAddress (params?: {}): Promise<Dict>;
    privateGetGetAddressBook (params?: {}): Promise<Dict>;
    privateGetGetCurrentDepositAddress (params?: {}): Promise<Dict>;
    privateGetGetDeposits (params?: {}): Promise<Dict>;
    privateGetGetRewardEligibility (params?: {}): Promise<Dict>;
    privateGetGetTransfers (params?: {}): Promise<Dict>;
    privateGetGetWithdrawals (params?: {}): Promise<Dict>;
    privateGetRemoveFromAddressBook (params?: {}): Promise<Dict>;
    privateGetSetClearanceOriginator (params?: {}): Promise<Dict>;
    privateGetSubmitTransferToSubaccount (params?: {}): Promise<Dict>;
    privateGetSubmitTransferToUser (params?: {}): Promise<Dict>;
    privateGetUpdateInAddressBook (params?: {}): Promise<Dict>;
    privateGetWithdraw (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
